import { render, staticRenderFns } from "./WhiteLoader.vue?vue&type=template&id=e5ba0bee&scoped=true&"
var script = {}
import style0 from "./WhiteLoader.vue?vue&type=style&index=0&id=e5ba0bee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ba0bee",
  null
  
)

export default component.exports